module.exports = __webpack_public_path__ + "static/media/tds_logo.14fdd4a3.png";